import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { RolCodigo } from '../types/database.types';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Si se omite, cualquier usuario autenticado puede entrar. */
  roles?: RolCodigo[];
}

/**
 * Guarda de rutas — solo para experiencia de usuario (evita el parpadeo
 * de una pantalla a la que el rol no tiene acceso). La autorización real
 * la aplica RLS en Supabase: si alguien evade este componente, las
 * consultas igual devuelven vacío o error. Ver ARQUITECTURA_FRONTEND.md
 * sección 5.
 */
export function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { session, perfil, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-onyx/60">
        Cargando…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && perfil && !roles.includes(perfil.rol)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 text-center">
        <p className="text-lg font-medium text-onyx">No tienes permiso para ver esta página</p>
        <p className="text-sm text-onyx/60">
          Tu rol ({perfil.rol}) no tiene acceso a este módulo.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
